import "./App.css";
import { Toaster } from 'sonner';
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ApartmentsSection from "./components/ApartmentsSection";
import GallerySection from "./components/GallerySection";
import AmenitiesSection from "./components/AmenitiesSection";
import LocationSection from "./components/LocationSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <Header />
      <main>
        <HeroSection />
        <ApartmentsSection />
        <GallerySection />
        <AmenitiesSection />
        <LocationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
